<template>
  <button class="start-btn text-white font-extrabold tracking-wide text-lg" @click="$emit('click')">
    <span
      v-for="(char, idx) in letters"
      :key="`${char}-${idx}`"
      class="start-letter"
      :style="{ '--i': idx }"
    >
      {{ char }}
    </span>
  </button>
</template>

<script>
export default {
  name: 'AnimatedButton',
  props: {
    label: {
      type: String,
      default: 'START',
    },
  },
  computed: {
    letters() {
      return this.label.split('');
    },
  },
};
</script>

<style scoped>
.start-btn {
  position: relative;
  padding: 14px 44px;
  border-radius: 14px;
  background: linear-gradient(180deg, #6ef34a 0%, #48c11f 100%);
  box-shadow:
    0 8px 16px rgba(0, 0, 0, 0.35),
    inset 0 -4px 8px rgba(0, 0, 0, 0.25),
    inset 0 4px 8px rgba(255, 255, 255, 0.2);
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.35);
  letter-spacing: 0.08em;
  overflow: hidden;
  transition:
    transform 0.16s ease,
    box-shadow 0.16s ease,
    filter 0.16s ease;
  animation: pulseGlow 2.6s ease-in-out infinite;
}

.start-btn::after {
  content: '';
  position: absolute;
  top: 0;
  left: -120%;
  width: 60%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.5), transparent);
  transform: skewX(-20deg);
  animation: shine 2.4s linear infinite;
}

.start-btn:hover {
  transform: translateY(-1px) scale(1.01);
  box-shadow:
    0 12px 22px rgba(0, 0, 0, 0.4),
    inset 0 -4px 8px rgba(0, 0, 0, 0.25),
    inset 0 4px 8px rgba(255, 255, 255, 0.2);
  filter: saturate(1.05);
}

.start-btn:active {
  transform: translateY(1px) scale(0.99);
  box-shadow:
    0 6px 12px rgba(0, 0, 0, 0.35),
    inset 0 -2px 6px rgba(0, 0, 0, 0.25),
    inset 0 4px 8px rgba(255, 255, 255, 0.2);
}

.start-letter {
  display: inline-block;
  animation: letterBounce 1.2s ease-in-out infinite;
  animation-delay: calc(var(--i) * 0.08s);
}

@keyframes shine {
  0% {
    left: -120%;
  }
  60% {
    left: 140%;
  }
  100% {
    left: 140%;
  }
}

@keyframes pulseGlow {
  0%,
  100% {
    box-shadow:
      0 8px 16px rgba(0, 0, 0, 0.35),
      0 0 0 0 rgba(110, 243, 74, 0.35),
      inset 0 -4px 8px rgba(0, 0, 0, 0.25),
      inset 0 4px 8px rgba(255, 255, 255, 0.2);
  }
  50% {
    box-shadow:
      0 8px 16px rgba(0, 0, 0, 0.35),
      0 0 0 10px rgba(110, 243, 74, 0.05),
      inset 0 -4px 8px rgba(0, 0, 0, 0.25),
      inset 0 4px 8px rgba(255, 255, 255, 0.2);
  }
}

@keyframes letterBounce {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-2px);
  }
}
</style>
